import ColumnDataStorage from "../modules/data-storage";
/**
 * @param {Columns} model
 * @param {Object} config
 */
var CellMiddleware = function (model, config) {
    config.forEach(function (editvalue) {
        var cell = model.get(editvalue.id, editvalue.column_name);
        if (!cell) {
            return;
        }
        var settings = cell.getSettings().editable;
        if (!settings) {
            return;
        }
        if (settings.hasOwnProperty('store_values') && !settings.store_values) {
            editvalue.formatted_value = editvalue.value;
            editvalue.value = Object.keys(editvalue.value);
        }
        if (settings.hasOwnProperty('store_single_value') && settings.store_single_value) {
            editvalue.formatted_value = editvalue.value;
            editvalue.value = Object.keys(editvalue.value)[0];
        }
        cell.dataStorage = new ColumnDataStorage(editvalue);
    });
    return model;
};
export default CellMiddleware;
